import {
    validateSingleSelection,
    validateAccountNumber,
    validateDate,
} from '@om/validation';
import {  validateFullName } from '@om/validation/src/validators/string-validator';
import { setKmfBankingDetailsFieldValid } from '../../../actions/kaMetlhaFuneralCover/bankingDetails';

let prevValidationAction = null;

export const bankingDetailsValidations = (store, next, action) => {
    const getTommorowsDate = () => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1);
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const getDateAfterThirtyDays = () => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 30);
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const validationAction = (() => {
        let error;
        const trimValue = (value) => (value ? value.trim() : value);
        switch (action.value.fieldType) {
            case 'bankName':
                error = validateSingleSelection(action.value.value, 'Bank Name');
                break;

            case 'branchCode':
                error = validateSingleSelection(action.value.value, 'Branch Code');
                break;

            case 'accountHolder':
                error = validateFullName(action.value.value,{min:3, max:66,required:true,subject:'Account holder name'})
                break;

            case 'accountNumber':
                error = validateAccountNumber(action.value.value, {
                    min: 5,
                    max: 22,
                    subject: 'Account number',
                });
                break;

            case 'accountType':
                error = validateSingleSelection(action.value.value, 'Account type');
                break;


            case 'debitOrderDay':
                error = validateSingleSelection(action.value.value, 'Debit order day');
                break;
    
            case 'commencingMonth':
                error = validateDate(action.value.value, {
                    min: getTommorowsDate(),
                    max:getDateAfterThirtyDays(),
                    subject:'commencing month date',
                    required: true,
                });
                break;
            case 'paymentAuthorization':
                error = validateSingleSelection(action.value.value, 'terms and conditions');
                break;

            default:
                return null;
        }

        return setKmfBankingDetailsFieldValid(error, action.value.fieldType);
    })();

    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
